import { MailingListCommentSchema } from './mailing-list-comment.schema';

/**
 * Schema for a mailing list comment reply.
 *
 * Extends the `MailingListCommentSchema` by adding an optional array of replies,
 * each of which conforms to the `MailingListCommentSchema`.
 *
 * @remarks
 * This schema is used to represent threaded replies to mailing list comments,
 * allowing for nested comment structures.
 *
 * @see MailingListCommentSchema
 */
export const MailingListCommentReplySchema = MailingListCommentSchema.extend({
  replies: MailingListCommentSchema.array().optional(),
});
